import { useCallback, useState } from "react";
import { useUserPutRole } from "../../../fnx/user/userRole";
export var useAssignRoles = function () {
    var _a = useState(false), trigger = _a[0], setTrigger = _a[1];
    var _b = useState({}), roleRequest = _b[0], setRoleRequest = _b[1];
    var _c = useUserPutRole(trigger, roleRequest), responseUserPutRol = _c.responseUserPutRol, errorUserPutRol = _c.errorUserPutRol, loadingUserPutRol = _c.loadingUserPutRol;
    var handleAssignRoles = useCallback(function (userId, roles) {
        var request = {
            id: userId,
            roles: roles,
        };
        setRoleRequest(request);
        setTrigger(true);
    }, []);
    var resetTriggerPutRoles = useCallback(function () {
        setTrigger(false);
    }, []);
    return {
        handleAssignRoles: handleAssignRoles,
        resetTriggerPutRoles: resetTriggerPutRoles,
        loadingUserPutRol: loadingUserPutRol,
        errorUserPutRol: errorUserPutRol,
        responseUserPutRol: responseUserPutRol,
    };
};
